import * as ActionTypes from './../constants';
import { baseUrl } from './../index';
// import { AsyncStorage } from 'react-native';
import axios from 'axios';
import { getUserToken } from './../getUserToken';

export default function(state={}, action) {
    switch(action.type) {
        case ActionTypes.REQUEST_LESSON_PLANNER : 
            return {
                ...state,
                loading: true,
                error:false,
                errInfo: null, 
                response: null
            }
        case ActionTypes.RECEIVED_LESSON_PLANNER : 
            return {
                ...state,
                loading: false,
                response: action.res,
                error: false,
                errInfo: null
            }
        case ActionTypes.ERROR_LESSON_PLANNER: 
            return {
                ...state,
                loading: false,
                error: true,
                errInfo: action.err,
                response: null
            }
        case ActionTypes.CLEAR_LESSON_PLANNER: 
            return { }
        default :  return state
    }

}

const dispatchRequestLessonPlanner = courseId => ({
    type:ActionTypes.REQUEST_LESSON_PLANNER,
    courseId
})

const dispatchReceivedLessonPlanner = res =>({
    type:ActionTypes.RECEIVED_LESSON_PLANNER,
    res
})

const dispatchErrorLessonPlanner = (err) => ({
    type:ActionTypes.ERROR_LESSON_PLANNER,
    err
})

const dispatchClearLessonPlanner= () => ({
    type: ActionTypes.CLEAR_LESSON_PLANNER
})

export const clearLessonPlannerData = () => dispatchClearLessonPlanner();

export const getLessonPlanner = courseId => dispatch => {

    dispatch(dispatchRequestLessonPlanner(courseId));   

    const data = {course_id: courseId};

    getUserToken()
        .then( authKey => {
            const options = {
                method: 'post',
                url: `${baseUrl}/api/lessonplanners`,
                data,
                headers: {
                    'Authorization': `Bearer ${authKey}`
                }
            }
            return axios(options)
                .then(({data}) => {
                    dispatch(dispatchReceivedLessonPlanner(data))
                })
        })
        .catch(e => dispatch(dispatchErrorLessonPlanner(e)));    
}
